<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>My Sent Transfer Request</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">My Sent Transfer Request</ion-title>
                </ion-toolbar>
            </ion-header>
            
            <div id="container">
                <DataTable :loading="loading" class="p-datatable-sm" showGridlines :value="transfers" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"  @page="onPage($event)" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column field="id" header="ID"></Column>
                    <Column field="qty" header="QTY"></Column>
                    <Column field="serial" header="Serial(s)">
                        <template #body="{data}">
                            <div v-html="data.serial"></div>
                        </template>
                    </Column>
                    <Column field="from" header="from"></Column>
                    <Column field="via" header="Via"></Column>
                    <Column field="to" header="To"></Column>
                    <Column field="createdBy" header="Created By"></Column>
                    <Column field="remarks" header="Remarks"></Column>
                    <Column field="createdAt" header="Created At"></Column>
                    <Column field="status" header="Status">
                    <template #body="{data}">
                            {{data.status}}
                            <br>
                            <div v-if="data.status=='Confirmed'" >
                                By: {{data.confirmedBy}} <br>
                                At: {{data.confirmedAt}}
                            </div>
                            <div v-if="data.status=='Declined'">
                                Reason: {{data.declineMessage}}
                            </div>
                        </template>
                    </Column>
                    <!-- <Column field="updatedBy" header="Updated By">
                        <template #body="{data}">
                            <div v-html="data.details"></div>
                        </template>
                    </Column> -->
                </DataTable>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default defineComponent({
  name: 'My Sent Transfer Request',
  data(){
      return {
          transfers:[],
          loading:false,
          perPage:10,
          total:0,
      }
  },
  mounted(){
      this.loadData(0);
  },
  methods:{
      async loadData(page){
          const data={
              'page':page + 1,
              'username':window.localStorage.username,
              'password':window.localStorage.password,
          };
          this.loading=true;
        this.$http.post('mySentGpsDeviceTransferRequests',data).then(response=>{
            // const rows=[];
            this.perPage=response.data.per_page;
            this.total=response.data.total;
            const reqs=[];
            for(const req of response.data.data){
                let serial="";
                for(const dev of req.gps_devices){
                    serial+=dev.serial+" <br>";
                }
                let from="";
                if(req.fromable!=null && req.fromable_type=="User"){
                    from=req.fromable.name;
                    if(req.fromable.distribution_point!=null){
                        from+=' ('+req.fromable.distribution_point.distribution_point_name+')';
                    }
                }else if(req.fromable!=null && req.fromable_type=="Ship"){
                    from=req.fromable.ship_name;
                }
                let to="";
                if(req.toable!=null && req.toable_type=="User"){
                    to=req.toable.name;
                    if(req.toable.distribution_point!=null){
                        to+=' ('+req.toable.distribution_point.distribution_point_name+')';
                    }
                }else if(req.toable!=null && req.toable_type=="Ship"){
                    to=req.toable.ship_name;
                }
                reqs.push({
                    serial: serial,
                    id:req.id,
                    qty:req.gps_devices.length,
                    from:from,
                    via:req.via,
                    to:to,
                    createdBy:req.created_by.name,
                    remarks: req.remarks,
                    createdAt: req.created_at,
                    status:req.status,
                    declineMessage:req.decline_message,
                    confirmedBy:req.confirmed_by!=null?req.confirmed_by.name:'',
                    confirmedAt:req.confirmed_at,
                });
            }
            this.transfers=reqs;
            this.loading=false;
        });

      },
      onPage(event){
          this.loadData(event.page);
      }
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    DataTable,
    Column
  }
});
</script>

<style scoped>
.dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
}
</style>